module.exports = __webpack_public_path__ + "static/media/view_similar1.aa3c021b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/view_similar1.png
 ** module id = 259
 ** module chunks = 0
 **/